import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Calendar, GraduationCap, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { Formation } from '../data/constants';
interface FormationCardProps {
  formation: Formation;
}
export function FormationCard({
  formation
}: FormationCardProps) {
  return <Card className="flex flex-col h-full shadow-lg border-none hover:-translate-y-2 hover:shadow-xl transition-all duration-500 overflow-hidden group bg-white" data-id="element-350">
      <div className="h-2 w-full bg-primary group-hover:bg-brand-orange transition-colors duration-500" data-id="element-351" />
      <CardHeader className="pt-8" data-id="element-352">
        <div className="flex flex-wrap gap-2 mb-4" data-id="element-353">
          <Badge variant="default" className="bg-lavande text-primary-dark hover:bg-lavande/80 border-none font-bold" data-id="element-354">
            {formation.level}
          </Badge>
          <Badge variant="outline" className="text-muted-foreground border-slate-200" data-id="element-355">
            {formation.rncp}
          </Badge>
        </div>
        <CardTitle className="text-2xl md:text-3xl leading-tight font-heading font-extrabold text-primary-dark group-hover:text-primary transition-colors" data-id="element-356">
          {formation.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 space-y-6" data-id="element-357">
        <p className="text-muted-foreground text-lg leading-relaxed line-clamp-3" data-id="element-358">
          {formation.description}
        </p>
        <div className="space-y-3 pt-6 border-t border-slate-100 text-base text-muted-foreground" data-id="element-359">
          <div className="flex items-center gap-3 group/item" data-id="element-360">
            <Clock className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-361" />
            <span className="font-medium" data-id="element-362">Durée : {formation.duration}</span>
          </div>
          <div className="flex items-center gap-3 group/item" data-id="element-363">
            <Calendar className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-364" />
            <span className="font-medium" data-id="element-365">Rythme : {formation.rhythm}</span>
          </div>
          <div className="flex items-center gap-3 group/item" data-id="element-366">
            <GraduationCap className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-367" />
            <span className="font-medium" data-id="element-368">Rentrée : {formation.rentree}</span>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex flex-col sm:flex-row gap-4 pt-8 pb-8" data-id="element-369">
        <Button variant="outline" className="w-full text-primary-dark border-primary/20 hover:bg-primary/5 font-semibold" asChild data-id="element-370">
          <Link to={`/formations/${formation.id}`} data-id="element-371">Voir le programme</Link>
        </Button>
        <Button className="w-full group/btn bg-brand-orange hover:bg-[#E67E22] text-white font-semibold" asChild data-id="element-372">
          <Link to="/candidater" data-id="element-373">
            Candidater
            <ArrowRight className="w-5 h-5 ml-2 group-hover/btn:translate-x-1 transition-transform" data-id="element-374" />
          </Link>
        </Button>
      </CardFooter>
    </Card>;
}